import React, { useContext, useEffect, useState } from "react";
import { API_STATE } from "~/common/constants/state";
import useAlert from "~/common/hooks/useAlert";
import useRequest from "~/common/hooks/useRequest";
import { AppManContext } from "../../../RoundManContext";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

// ko img
import setupImg01 from "~/assets/img/round-setting-step1.png";
import setupImg02 from "~/assets/img/round-setting-step2.png";
import setupImg03 from "~/assets/img/round-setting-step3.png";

// en img
import enSetupImg02 from "~/assets/img/EN/round-setting-step2_en.png";
import enSetupImg03 from "~/assets/img/EN/round-setting-step3_en.png";
import Processing from "~/pages/investment/InvestSettingPage/processingModal/Processing";

const ProcessOne = ({
	processStep,
	setProcessStep,
	setEvaluateSetupModal,
	prcOneSelect,
	setPrcOneSelect,
	modiData,
}) => {
	const { t, i18n } = useTranslation();
	const roundDetailRequest = useRequest("get", "/vc/round/setting/detail");
	const { setResultProcessOne, resultProcessOne } = useContext(AppManContext);
	const [showSettingAlert, SettingAlert] = useAlert();
	const [showErrorAlert, ErrorAlert] = useAlert();
	const [changing, setChanging] = useState(false);

	const navigate = useNavigate();

	const [roundItemModal, setRoundItemModal] = useState(false);

	//----심사항목 삭제 Alert 모달 ----------------------------------------------------
	const [deleteAlertModal, setDeleteAlertModal] = useState(false);
	const [noCategoryAlert, setNoCategoryAlert] = useState(false);
	const [weightingAlert, setWeightingAlert] = useState(false);
	const [noEvaluationAlert, setNoEvaluationAlert] = useState(false);
	const [noTitleAlert, setNoTitleAlert] = useState(false);
	const [noCategoryName, setNoCategoryName] = useState(false);
	const [noItemName, setNoItemName] = useState(false);
	const [settingList, setSettingList] = useState([]);
	const [settingDetail, setSettingDetail] = useState({});
	const [evalCategories, setEvalCategories] = useState([]);
	const [step, setStap] = useState("");
	const settingListRequest = useRequest("get", "/vc/invest/setting/list");
	const settingCreateRequest = useRequest("post", "/vc/invest/setting/add");
	const settingModifyRequest = useRequest("post", "/vc/invest/setting/edit");

	const [resetItemData, setResetData] = useState("");
	const [targetIdx, setTargetIdx] = useState("");
	const [createNew, setCreateNew] = useState("create");
	const [isSelect, setIsSelect] = useState(false)

	useEffect(() => {
		settingListRequest.call();
	}, []);

	useEffect(() => {
		switch (settingListRequest.state) {
			case API_STATE.done:
				const resData = settingListRequest.response?.data.list;
				setSettingList(resData);
				break;
			case API_STATE.error:
				break;
			default:
				break;
		}
	}, [settingListRequest.state, settingListRequest.response, settingListRequest.error]);

	useEffect(() => {
		switch (settingCreateRequest.state) {
			case API_STATE.done:
				// let res = settingCreateRequest.response;
				// setSelectValue({
				// 	label: res.title, value: res.idx
				// })
				setRoundItemModal(false);
				settingListRequest.call();
				setIsSelect(true)
				break;
			case API_STATE.error:
				console.log("settingCreateRequest error !!! >> ", settingCreateRequest.error);
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [settingCreateRequest.state, settingCreateRequest.response, settingCreateRequest.error]);




	const handleNewCreation = (createFormData) => {
		settingCreateRequest.call(createFormData);
	};

	const handleModify = (modiFormData) => {
		settingModifyRequest.call(modiFormData);
	};


	const handleEvalSelect = (e) => {
		let detailIdx = e.target.value;

		setPrcOneSelect(detailIdx);
		if (detailIdx === 0 || detailIdx === "0") {
			setResultProcessOne("nope");
		} else {
			roundDetailRequest.call(detailIdx, "path");
		}
	};

	useEffect(() => {
		switch (roundDetailRequest.state) {
			case API_STATE.done:
				setResultProcessOne(roundDetailRequest.response.data);
				break;
			case API_STATE.error:
				console.log("얼마나 작동 error>> ", roundDetailRequest.error);
				setEvaluateSetupModal(false);
				alert(t("pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.alert"));
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [roundDetailRequest.state, roundDetailRequest.response, roundDetailRequest.error]);

	const validateForNextStep = () => {
		if (resultProcessOne === "nope") {
			showSettingAlert();
			return;
		} else {
			setProcessStep(processStep + 1);
		}
	};

	// const navigateToSetting = () => {
	// 	showErrorAlert().then(() => {
	// 		navigate("/round/setting");
	// 	});
	// };

	const changeReview = () => {
		setChanging(true);
	};

	useEffect(() => {
		if (isSelect && settingList && settingList.length > 0) {
			setPrcOneSelect(settingList[settingList.length - 1].idx);
		}
	}, [isSelect, settingList, setPrcOneSelect]);



	return (
		<>
			<div className="modal-content criteriaSetup">
				<div className="side-content">
					<h3>
						{t(
							"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.sideContent"
						)}
					</h3>
				</div>
				<section className="c__card">
					<div className="title">
						{t(
							"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.title"
						)}
					</div>
					{modiData && resultProcessOne.title && !changing ? (
						<div className="setting-init">
							<div className="setting-init-title">{resultProcessOne.title}</div>
							<button
								type="button"
								className="btn__solid angled btn-change"
								color="primary"
								onClick={changeReview}
							>
								변경
							</button>
						</div>
					) : (
						<select
							className="c__select"
							onChange={handleEvalSelect}
							value={prcOneSelect}
						>
							{settingList && (
								<option value={0}>
									{t(
										"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.selectDefault01"
									)}
								</option>
							)}
							{settingList ? (
								settingList.map((d, idx) => (
									<option value={d.idx} key={idx + 1}>
										{d.title}
									</option>
								))
							) : (
								<option value={1}>
									{t(
										"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.selectDefault02"
									)}
								</option>
							)}
						</select>
					)}

					<div className="setting-order">


						<p className="setting-notice">
							{
								modiData &&
								<p className={"update-setting-notice"}>※ 설정한 심사항목을 삭제한 경우에는 심사항목 변경시, 목록에서 삭제되어 선택이 불가능합니다.</p>
							}
							{t(
								"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.settingNotice"
							)}
							<button type="button" className="btn-link" onClick={
								() => setRoundItemModal(true)
							}>
								{t(
									"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.button"
								)}
							</button>
						</p>
						<ul className="setting-order-step">
							<li>
								<div className="step-img">
									<img
										src={setupImg01}
										alt={t(
											"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.imageAlt"
										)}
									/>
								</div>
								<p>
									{t(
										"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.step01"
									)}
								</p>
							</li>
							<li>
								<div className="step-img">
									<img
										src={i18n.language === "ko" ? setupImg02 : enSetupImg02}
										alt={t(
											"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.imageAlt"
										)}
									/>
								</div>
								<p>
									{t(
										"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.step02"
									)}
								</p>
							</li>
							<li>
								<div className="step-img">
									<img
										src={i18n.language === "ko" ? setupImg03 : enSetupImg03}
										alt={t(
											"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.imageAlt"
										)}
									/>
								</div>
								<p>
									{t(
										"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.step03"
									)}
								</p>
							</li>
						</ul>
					</div>
				</section>
			</div>
			<div className="modal-footer">
				<button
					type="button"
					className="btn__solid"
					color="gray"
					disabled={processStep === 0}
					onClick={() => setProcessStep(processStep - 1)}
				>
					{t("pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.prev")}
				</button>
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={validateForNextStep}
				// onClick={showConfirmAlert}
				// onClick={showExternalAlert}
				>
					{t("pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.next")}
				</button>
			</div>

			<SettingAlert
				type="warning"
				message={t(
					"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.selectWarning"
				)}
				confirm={t(
					"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.confirm"
				)}
			/>

			<ErrorAlert
				message={t(
					"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.errorWarningTitle"
				)}
				subMessage={t(
					"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.errorWarningText"
				)}
				type="warning"
				confirm={t(
					"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.confirm"
				)}
				reject={t(
					"pages.round.RoundManage.modal.evaluationSetting.steps.ProcessOne.reject"
				)}
			/>
			<Processing
				{...{
					settingDetail,
					setSettingDetail,
					createNew,
					roundItemModal,
					setRoundItemModal,
					setNoCategoryAlert,
					setWeightingAlert,
					setNoEvaluationAlert,
					setNoTitleAlert,
					resetItemData,
					setResetData,
					setNoCategoryName,
					setNoItemName,
					handleModify,
					handleNewCreation,
					targetIdx,
				}}
			/>
		</>
	);
};

export default ProcessOne;
